import { useRouter } from 'next/router'

const determineIfSlug = (slug, router) => {
  if (!(router instanceof Object)) {
    throw Error(
      'Make sure the Nextjs router object has been passed to the function.',
    )
  }

  const slugParams = slug.split('/')
  if (typeof router.query.slug === 'object') {
    // check if every router param is inside the slugParams parameter
    return router.query.slug.every(param => slugParams.includes(param))
  } else if (router.query.slug === undefined) {
    return slug === ''
  } else {
    return router.query.slug === slugParams[0]
  }
}

const useIsSlug = (slug = '') => {
  const router = useRouter()
  return determineIfSlug(slug, router)
}

export { useIsSlug, determineIfSlug }
